var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3367 16.0075H17.7202C17.7202 20.1879 17.7202 25.3334 17.7202 25.3334H13.843C13.843 25.3334 13.843 20.2377 13.843 16.0075H12V12.7115H13.843V10.5795C13.843 9.05264 14.5686 6.66675 17.7558 6.66675L20.6288 6.67776V9.8773C20.6288 9.8773 18.883 9.8773 18.5435 9.8773C18.2041 9.8773 17.7215 10.047 17.7215 10.7752V12.7121H20.6755L20.3367 16.0075Z",
    fill: "#C2D1D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_826_17180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 6,
    width: 9,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3367 16.0075H17.7202C17.7202 20.1879 17.7202 25.3334 17.7202 25.3334H13.843C13.843 25.3334 13.843 20.2377 13.843 16.0075H12V12.7115H13.843V10.5795C13.843 9.05264 14.5686 6.66675 17.7558 6.66675L20.6288 6.67776V9.8773C20.6288 9.8773 18.883 9.8773 18.5435 9.8773C18.2041 9.8773 17.7215 10.047 17.7215 10.7752V12.7121H20.6755L20.3367 16.0075Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_826_17180)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.ddeb29c933b4e8e729fc1c97d782d030.svg";
export { ForwardRef as ReactComponent };